import React, { Component } from "react";
import Popup from "../../../common/Popup";
import PDF from "../../../../assets/file/PDF.svg";
import JPEG from "../../../../assets/file/JPEG.svg";
import PNG from "../../../../assets/file/PNG.svg";
import ReactTooltip from 'react-tooltip';
import ic_document from "../../../../assets/icons/ic_document.png";

import { DKLabel, DKButton, INPUT_VIEW_DIRECTION, DKCheckMark, DKLine, DKSpinner, showAlert, DKInput, INPUT_TYPE, DKIcon, showToast, TOAST_TYPE, DKIcons, showLoader, removeLoader, DKListPicker, DKCalendar, DKStatus, Toggle } from "deskera-ui-library";
class RejectInvestment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reason: ""
        }
        setTimeout(() => {
            ReactTooltip.rebuild();
        }, 1000)
    }
    onClose() {
        this.props.onClose()
    }
    onReject() {
        if (this.state.reason.trim() == "") {
            this.setState({ reason: this.state.reason })
            return;
        }
        this.props.onReject(this.state.reason)
    }
    getFilename(url) {
        return url.substring(url.indexOf("_") + 1, url.length);
    }
    getFiles() {


        return (<div className="row align-items-start">
            {this.props.files.map((url, i) => {
                return (
                    <>
                        {url && <div key={url} className="column align-items-center mr-s">
                            <ReactTooltip type="dark" place="right" html={true} effect='solid' />
                            <span data-tip={this.getFilename(url)}>
                                <DKIcon
                                    className="ic-s mb-s cursor-hand"
                                    src={ic_document}
                                    onClick={() => {
                                        this.props.downloadAttachment(url);
                                    }}
                                />
                            </span>
                        </div>}
                    </>
                )
            })}
        </div>)


    }
    render() {
        return (
            <>
                <Popup>

                        <ReactTooltip type="dark" place="right" html={true} effect='solid' />
                        <div >
                            <div className="parent-width" style={{ display: "flex" }}>
                                <DKLabel text={this.props.title} className="fs-m fw-m align-self-center width-80" />
                                <div className="d-flex m-v-s ">
                                    <DKButton
                                        title="Cancel"
                                        className="g-gray1 border-m"
                                        onClick={(event) => {
                                            this.onClose();
                                        }}
                                    />
                                    <DKButton
                                        title="Reject"
                                        className="border-m ml-r bg-app text-white border-n"
                                        onClick={() => this.onReject()}
                                    />

                                </div>
                            </div>
                            <div className="parent-width border-box bg-white border-radius-s mt-xxl">
                                <DKLabel text={this.props.sectionName} className="fs-m fw-m align-self-center width-80" />
                                <DKLabel text={`Amount Per Month`} className="fs-m fw-m text-gray align-self-center width-80 mt-xl" />
                                <DKLabel text={this.props.amount} className="fs-m fw-m  align-self-center width-80 mt-xs" />
                                <DKLabel text={`Attachments`} className="fs-m fw-m align-self-center width-80 mt-xl text-gray" />
                                <div className="d-flex mt-s">
                                    {this.getFiles()}
                                </div>

                                <DKInput
                                    className="mt-s textarea-resize"
                                    type="text"
                                    value={this.state.reason}
                                    showError={true}
                                    readOnly={false}
                                    canValidate={true}
                                    required={true}
                                    direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                    title="Rejection Reason"
                                    onChange={(value) => {
                                        this.setState({ reason: value });
                                    }} />

                            </div>

                        </div>
                </Popup>
            </>
        )
    }
}
export default RejectInvestment